(() => {
  if (customElements.get('ov-cart-drawer')) return;
  class OvCartDrawer extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.panel = this.querySelector('dialog');
      this.busy = false;
      this.dataset.ovBound = 'true';
      this.localizeVariants();
      this.syncTerms();
      this.addEventListener("change",event=>{if(event.target.matches("[data-ov-cart-terms]"))this.syncTerms();},options);
      if (this.dataset.enabled === 'true') document.querySelectorAll('.dog-cart-link').forEach(link => {link.setAttribute('role','button'); link.setAttribute('data-ov-cart-open','');});
      this.addEventListener('click', event => {
        if (event.target.closest('[data-ov-cart-close]')) this.close();
        const checkout=event.target.closest('.ov-cart-checkout');
        if(checkout){
          event.preventDefault();
          if(this.busy)return;
          const terms=this.querySelector("[data-ov-cart-terms]");
          if(terms&&!terms.checked){terms.reportValidity();return;}
          this.busy=true;checkout.setAttribute('aria-busy','true');
          const error=this.querySelector('[data-ov-cart-error]');error.hidden=true;
          (async()=>{try{
            if(terms){const acceptance=await fetch(this.dataset.root+"cart/update.js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({attributes:{"אישור תקנון":"כן"}})});if(!acceptance.ok)throw new Error("לא הצלחנו לשמור את אישור התקנון. נסו שוב.");}
            const cart=await DogCommerce.verifyCart(this);
            if(!cart.item_count)throw new Error('העגלה ריקה. בחרו מוצר לפני מעבר לתשלום.');
            location.assign(checkout.dataset.checkoutUrl);
          }catch(problem){error.textContent=problem.message;error.hidden=false;}
          finally{this.busy=false;checkout.removeAttribute('aria-busy');}})();
        }
        const change = event.target.closest('[data-ov-cart-change]');
        if (change) this.change(change);
        if (event.target === this.panel && this.dataset.closeOverlay === 'true') {
          const bounds = this.panel.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.close();
        }
      }, options);
      this.panel.addEventListener('cancel', event => {event.preventDefault(); this.close();}, options);
      this.panel.addEventListener('close', () => {this.dataset.lastState = 'closed'; document.documentElement.classList.remove('ov-cart-open'); this.trigger?.focus({preventScroll:true});}, options);
      document.addEventListener('ovellor:cart-added', async event => {
        if (this.dataset.enabled !== 'true') return;
        try {
          if (this.dataset.autoOpen === 'true') this.open(event.detail?.trigger);
          await this.refresh();
        } catch (error) {
          console.warn('[OVELLOR cart drawer]', error);
          const status = event.detail?.status;
          if (status) status.append(document.createTextNode(' אפשר לצפות במוצרים בעגלה המלאה.'));
        }
      }, options);
      document.addEventListener('click', async event => {
        if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || (typeof event.button === 'number' && event.button !== 0)) return;
        const target = event.target instanceof Element ? event.target : event.target?.parentElement;
        if (!target) return;
        const link = target.closest('a[href]');
        if (link && (link.hasAttribute('download') || (link.target && link.target !== '_self'))) return;
        const trigger = target.closest('[data-ov-cart-open]');
        if (trigger) {
          event.preventDefault();
          if (this.dataset.enabled !== 'true') {location.assign(this.dataset.cartUrl); return;}
          this.open(trigger);
          try {await this.refresh();} catch (error) {const node=this.querySelector('[data-ov-cart-error]'); node.textContent=error.message; node.hidden=false;}
          return;
        }
        if (this.dataset.enabled !== 'true') return;
        if (!link || this.contains(link)) return;
        const url = new URL(link.href, location.href);
        // Intercept the cart route only; root_url is the storefront home page.
        const cart = new URL(this.dataset.cartUrl, location.origin);
        if (url.origin !== cart.origin || url.pathname !== cart.pathname) return;
        event.preventDefault();
        this.dataset.lastState = 'clicked';
        try {this.open(link); await this.refresh();} catch (error) {console.warn('[OVELLOR cart drawer]', error.message); this.open(link); const node = this.querySelector('[data-ov-cart-error]'); node.textContent = error.message + ' אפשר להמשיך דרך העגלה המלאה.'; node.hidden = false;}
      }, {signal: this.abort.signal, capture:true});
    }
    disconnectedCallback() {
      this.abort?.abort();
      clearTimeout(this.closeTimer);
      if (this.panel?.open) document.documentElement.classList.remove('ov-cart-open');
    }
    open(trigger) {
      clearTimeout(this.closeTimer);
      this.panel.classList.remove('ov-cart-closing');
      if (this.panel.open) return;
      this.trigger = trigger instanceof HTMLElement ? trigger : document.activeElement;
      this.panel.showModal();
      this.dataset.lastState = 'opened';
      document.documentElement.classList.add('ov-cart-open');
    }
    close() {
      if (!this.panel.open || this.panel.classList.contains('ov-cart-closing')) return;
      const duration = this.dataset.animation === 'none' || matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : Number(this.dataset.duration);
      this.panel.classList.add('ov-cart-closing');
      this.closeTimer = setTimeout(() => {this.panel.close(); this.panel.classList.remove('ov-cart-closing');}, duration);
    }
    localizeVariants() {
      if (typeof DogCommerce === 'undefined') return;
      for (const node of this.querySelectorAll('[data-ov-cart-variant]')) node.textContent=DogCommerce.variantLabel(node.dataset.ovCartVariant,node.textContent);
    }
    syncTerms() {
      const terms=this.querySelector("[data-ov-cart-terms]"),button=this.querySelector(".ov-cart-checkout");
      if(button){button.disabled=Boolean(terms&&!terms.checked);button.setAttribute("aria-disabled",String(button.disabled));}
    }
    async refresh() {
      const url = new URL(this.dataset.cartUrl, location.origin);
      url.searchParams.set('sections', this.dataset.sectionId);
      const response = await fetch(url, {headers:{Accept:'text/html'}, cache:'no-store'});
      if (!response.ok) throw new Error('טעינת העגלה נכשלה.');
      const data = await response.json();
      this.render(data[this.dataset.sectionId]);
    }
    render(html) {
      if (!html) throw new Error('העגלה אינה זמינה כרגע.');
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const incoming = doc.querySelector('ov-cart-drawer');
      if (!incoming) throw new Error('העגלה אינה זמינה כרגע.');
      const active = this.panel.contains(document.activeElement) ? document.activeElement : null;
      const oldLine = active?.closest('[data-ov-cart-line]')?.dataset.ovCartLine;
      const oldLabel = active?.getAttribute('aria-label');
      for (const selector of ['[data-ov-cart-benefits]','[data-ov-cart-content]','[data-ov-cart-footer]']) {
        const oldNode = this.querySelector(selector), nextNode = incoming.querySelector(selector);
        if (oldNode && nextNode) oldNode.replaceWith(nextNode);
        else if (oldNode) oldNode.remove();
        else if (nextNode) this.panel.append(nextNode);
      }
      const cart = JSON.parse(incoming.querySelector('[data-ov-cart-data]').textContent);
      this.localizeVariants();
      this.syncTerms();
      this.querySelector('[data-ov-cart-count]').textContent = cart.item_count;
      document.querySelectorAll('[data-dog-cart-count]').forEach(node => node.textContent = cart.item_count);
      this.querySelector('[data-ov-cart-error]').hidden = true;
      if (active) {
        const line = [...this.querySelectorAll('[data-ov-cart-line]')].find(node => node.dataset.ovCartLine === oldLine);
        const button = line && [...line.querySelectorAll('button')].find(node => node.getAttribute('aria-label') === oldLabel);
        (button || this.querySelector('[data-ov-cart-close]')).focus({preventScroll:true});
      }
    }
    async change(button) {
      if (this.busy) return;
      this.busy = true;
      this.panel.setAttribute('aria-busy','true');
      const errorNode = this.querySelector('[data-ov-cart-error]');
      errorNode.hidden = true;
      try {
        const response = await fetch(this.dataset.root + 'cart/change.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:button.dataset.key,quantity:Number(button.dataset.ovCartChange),sections:[this.dataset.sectionId],sections_url:location.pathname})});
        const cart = await response.json();
        if (!response.ok) throw new Error(cart.description || cart.message || 'לא הצלחנו לעדכן את הכמות.');
        if (cart.sections?.[this.dataset.sectionId]) this.render(cart.sections[this.dataset.sectionId]);
        else await this.refresh();
      } catch (error) {
        errorNode.textContent = error.message;
        errorNode.hidden = false;
      } finally {
        this.busy = false;
        this.panel.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('ov-cart-drawer', OvCartDrawer);
})();
